import React from 'react';
import PropTypes from 'prop-types';

import Link from 'react-router/lib/Link';

const Layout = ({ brandId, children }) => (
  <div>
    <div className="u-max-width-710 u-margin-auto u-ph- large-and-up-ph0 u-bg-white">
      <ul className="c-nav-tabs list-bare u-mt- medium-and-up-mt">
        <li>
          <Link
            to={`/admin/brands/${brandId}/import/customers`}
            className="c-nav-tab u-fontsize-extrasmall"
            activeClassName="is-active"
          >
            Clients
          </Link>
        </li>
        <li>
          <Link
            to={`/admin/brands/${brandId}/import/gift-cards`}
            className="c-nav-tab u-fontsize-extrasmall"
            activeClassName="is-active"
          >
            Gift Cards
          </Link>
        </li>
        <li>
          <Link
            to={`/admin/brands/${brandId}/import/products`}
            className="c-nav-tab u-fontsize-extrasmall"
            activeClassName="is-active"
          >
            Products
          </Link>
        </li>
        <li>
          <Link
            to={`/admin/brands/${brandId}/import/services`}
            className="c-nav-tab u-fontsize-extrasmall"
            activeClassName="is-active"
          >
            Services
          </Link>
        </li>
      </ul>
    </div>
    <div className="u--mt-- large-and-up--mt">{children}</div>
  </div>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  brandId: PropTypes.string.isRequired,
};

export default Layout;
